import { render, staticRenderFns } from "./newCase.vue?vue&type=template&id=7b42a933&scoped=true"
import script from "./newCase.js?vue&type=script&lang=js&external"
export * from "./newCase.js?vue&type=script&lang=js&external"
import style0 from "./newCase.vue?vue&type=style&index=0&id=7b42a933&prod&lang=scss&scoped=true"
import style1 from "./newCase.vue?vue&type=style&index=1&id=7b42a933&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b42a933",
  null
  
)

export default component.exports